"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dynamicModifiers = require("../../../utils/dynamicModifiers");

var _styleModifiers = require("../../../utils/styleModifiers");

var _constants = require("../constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ItemWrapper = _styledComponents.default.li.withConfig({
  displayName: "ItemWrapper",
  componentId: "fky2d1-0"
})(["display:flex;margin:0;position:relative;white-space:normal;", " &:focus{outline:none;}", ";", ";"], (0, _dynamicModifiers.applyDynamicModifiers)('flexDirection', 'flex-direction'), (0, _styleModifiers.when)('active', (0, _styledComponents.css)(["background-color:", ";&::before{border-left:4px solid ", ";position:absolute;top:0;left:0;height:100%;content:'';pointer-events:none;}"], (0, _toColorString.default)(_constants.ACTIVE_BG_COLOR), (0, _toColorString.default)(_constants.ACTIVE_BORDER_COLOR))), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["&:hover{background-color:", ";}"], (0, _toColorString.default)(_constants.BG_COLOR))));

var _default = ItemWrapper;
exports.default = _default;